module.exports = __webpack_public_path__ + "static/media/bts_lalela_170711_028_small.06922e58.jpg";